module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-4 col-xs-12\"> <span class=q-tag> {%= dosDay.dosDay %} </span> </div> {%= dosTimes %} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/dockConfigurations/html/dockConfigNewEdit/html/dockShiftDays.html
// module id = 1266
// module chunks = 1